export default "/images/help_circle.svg?b473ee800b17200c2e63856919cc6f46";